import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface EmailsTableProps {
}

export const EmailsTable: React.FC<EmailsTableProps> = () => {

    const emailsState = useAppSelector(state => state.emails);

    return (
        <table className="data">
            <thead>
            <tr>
                <th style={{width: '70px'}}>Kellaaeg</th>
                <th style={{width: '90px'}}>Logistik</th>
                <th style={{width: '100px'}}>Saaja</th>
                <th style={{width: '150px'}}>Pealkiri</th>
                <th className="w150">Kategooriad</th>
                <th className="right w150">Tekst</th>
            </tr>
            </thead>
            <tbody>
            {emailsState.emails.map( email => (
                <tr key={email.id}>
                    <td>{email.time}</td>
                    <td>{email.user?.firstname}</td>
                    <td>{email.contact?.name}</td>
                    <td>{email.title}</td>
                    <td>{email.category_names}</td>
                    <td>{email.content}</td>
                </tr>
            ))}
            </tbody>
        </table>
    )

}